import React from 'react';
import SettlementReport from '../Merchants/SettlementReport';

const PuppeteerCreateSettlementReport = () => {
  let wallet = null;
  let merchant = null;

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('business_name') && urlParams.has('merchant_id') && urlParams.has('merchant_code') &&
    urlParams.has('wallet_currency_code') && urlParams.has('card_settlement_period')) {
    wallet = {
      code: urlParams.get('wallet_currency_code'),
    };
    merchant = {
      name: urlParams.get('business_name'),
      merchant_id: urlParams.get('merchant_id'),
      merchant_code: urlParams.get('merchant_code'),
      card_settlement_period: urlParams.get('card_settlement_period'),
      _id: urlParams.get('merchant_id'),
      enable_affiliate: false,
    };
  }

  if (!wallet || !merchant) {
    return <div id="missing-params" />;
  }

  return (
    <SettlementReport {...{
      wallet,
      handleChange: () => { },
      isAffiliate: false,
      selectedMerchant: merchant,
    }}
    />
  );
};

export default PuppeteerCreateSettlementReport;
